import { render, staticRenderFns } from "./ContactInformationInstitutionProfile.vue?vue&type=template&id=613038e4&scoped=true&"
import script from "./ContactInformationInstitutionProfile.vue?vue&type=script&lang=ts&"
export * from "./ContactInformationInstitutionProfile.vue?vue&type=script&lang=ts&"
import style0 from "./ContactInformationInstitutionProfile.vue?vue&type=style&index=0&id=613038e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613038e4",
  null
  
)

export default component.exports